import { API } from '../../../config'
import { errorHandler } from '../auth/errorAction'

export const unmountFavorite = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_FAVORITE'})
}

export const listFavorite = (params) => async (dispatch) => {
  await dispatch({ type: 'LOAD_FAVORITE' })
  return API.GET('/job-favorite/list', params).then((response) => {
    dispatch({
      type: 'LOAD_FAVORITE_SUCCESS', 
      payload: {
        data: response.data
    }})
  }).catch((err) => {
    return dispatch(errorHandler(
      err.error || err.message, 
      dispatch({ type: 'LOAD_FAVORITE_FAILED' }), 
    ))
  })
}

export const addOrDeleteFavorite = (value, successCB, failedCB) => async dispatch => {
  API.POST_WITH_PARAMS('/job-favorite/addOrDelete', value).then((response) => {
    return successCB && successCB(response)
  })
  .catch((err) => {
    return failedCB && failedCB(err.error || err.message)
  })
}